import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { requestRefDataFeatureKey, RequestRefDataState } from './refdata.reducer';

export const selectRequestRefDataState = createFeatureSelector<RequestRefDataState>(
  requestRefDataFeatureKey
);

export const selectRefData = createFeatureSelector<RequestRefDataState>(
  requestRefDataFeatureKey
);

export const selectPaymentTypes = createSelector(
  selectRefData,
  (state) => state.paymentTypes
);

export const selectDielines = createSelector(
  selectRefData,
  (state) => state.dielines
);

export const selectRequestItemTypes = createSelector(
  selectRefData,
  (state) => state.requestItemTypes
);

export const selectDataPinFileTypes = createSelector(
  selectRefData,
  (state) => state.dataPinFileTypes
);

export const selectRedemptionTypes = createSelector(
  selectRefData,
  (state) => state.redemptionTypes
);

export const selectSubstrates = createSelector(
  selectRefData,
  (state) => state.substrates
);

export const selectRegions = createSelector(
  selectRefData,
  (state) => state.regions
);

export const selectWarehouses = createSelector(
  selectRefData,
  (state) => state.warehouses
);

export const selectCompanies = createSelector(
  selectRefData,
  (state) => state.companies
);

export const selectPopProdInventoryTypes = createSelector(
  selectRefData,
  (state) => state.popProdInventoryTypes
);
// 2
export const selectPrinters = createSelector(
  selectRefData,
  (state) => state.printers
);

export const selectPartnerGroups = createSelector(
  selectRefData,
  (state) => state.partnerGroups
);

export const selectDesignLineOfBusiness = createSelector(
  selectRefData,
  (state) => state.designLineOfBusiness
);

export const selectArtLocationTypes = createSelector(
  selectRefData,
  (state) => state.artLocationTypes
);

export const selectDesignSourceTypes = createSelector(
  selectRefData,
  (state) => state.designSourceTypes
);

export const selectChannelTypes = createSelector(
  selectRefData,
  (state) => state.channelTypes
);

export const selectPopChannelTypes = createSelector(
  selectRefData,
  (state) => state.popChannelTypes
);

export const selectInventoryTypes = createSelector(
  selectRefData,
  (state) => state.inventoryTypes
);

export const selectComponentTypes = createSelector(
  selectRefData,
  (state) => state.componentTypes
);

export const selectPopItemTypes = createSelector(
  selectRefData,
  (state) => state.popItemTypes
);

export const selectColorTypes = createSelector(
  selectRefData,
  (state) => state.colorTypes
);

export const selectDimensionTypes = createSelector(
  selectRefData,
  (state) => state.dimensionTypes
);

export const selectFinancialTypes = createSelector(
  selectRefData,
  (state) => state.financialTypes
);

export const selectPopProdEventTypes = createSelector(
  selectRefData,
  (state) => state.popProdEventTypes
);

export const selectPopProdFundingTypes = createSelector(
  selectRefData,
  (state) => state.popProdFundingTypes
);

export const selectPopProdUsageDurationTypes = createSelector(
  selectRefData,
  (state) => state.popUsageDurationTypes
);

export const selectPopProdItemTypes = createSelector(
  selectRefData,
  (state) => state.popProdItemTypes
);

export const selectPopProdCuttingTypes = createSelector(
  selectRefData,
  (state) => state.popProdCuttingTypes,
);

export const selectPopProdMaterialTypes = createSelector(
  selectRefData,
  (state) => state.popProdMaterialTypes,
);

export const selectPopProdTapeTypes = createSelector(
  selectRefData,
  (state) => state.popProdTapeTypes,
);

export const selectFSPaymentTypes = createSelector(
  selectRefData,
  (state) => state.fsPaymentTypes
);

export const selectBifComponentTypes = createSelector(
  selectRefData,
  (state) => state.bifComponentTypes,
);

export const selectBifFulfillmentTypes = createSelector(
  selectRefData,
  (state) => state.bifFulfillmentTypes,
);

/**
 * ThirdPartyDataPinFileTypes
 */
export const selectThirdPartyDataPinFileTypes = createSelector(
  selectRefData,
  (state) => state.thirdPartyDataPinFileTypes,
);
/**
 * ThirdPartyOrderTypes
 */
export const selectThirdPartyOrderTypes = createSelector(
  selectRefData,
  (state) => state.thirdPartyOrderTypes,
);
/**
 * ThirdPartyPrintOwnerTypes
 */
export const selectThirdPartyPrintOwnerTypes = createSelector(
  selectRefData,
  (state) => state.thirdPartyPrintOwnerTypes,
);

export const selectThirdPartyCompanies = createSelector(
  selectRefData,
  (state) => state.thirdPartyCompanies,
);

export const selectIhComponents = createSelector(
  selectRefData,
  (state) => state.ihComponents,
);

export const selectIhHealthPlans = createSelector(
  selectRefData,
  (state) => state.ihHealthPlans,
);

export const selectIhHealthPrograms = createSelector(
  selectRefData,
  (state) => state.ihHealthPrograms,
);

export const selectIhPriorities = createSelector(
  selectRefData,
  (state) => state.ihPriorities,
);

export const selectIhPrioritiesPrioterized = createSelector(selectIhPriorities, priotiries =>
  UtilsService.sortByFields(priotiries, codeName => {
    if (codeName.value) {
      return codeName.value;
    }
    if (codeName.code === 'HIGH') {
      return 3 as number;
    }
    if (codeName.code === 'MEDIUM') {
      return 2 as number;
    }
    if (codeName.code === 'LOW') {
      return 1 as number;
    }

    return 0 as number;
  }).reverse()
);


export const selectReturnFileTypes = createSelector(
  selectRefData,
  (state) => state.returnFileTypes,
);

export const selectImageFormatTypes = createSelector(
  selectRefData,
  (state) => state.imageFormatTypes,
);
